import { useState } from 'react'
import { Lock, ArrowRight, GraduationCap } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import api from '../api/client'

// Tela exibida quando um PRÉ-LICENCIADO tenta acessar um recurso bloqueado (PRD).
export default function BloqueioPreLicenciado() {
  const nav = useNavigate()
  const [loading, setLoading] = useState(false)

  async function finalizar() {
    setLoading(true)
    try {
      const { data } = await api.post('/conta/licenca/checkout')
      const url = (data?.checkout_url || '').replace(/^\/#/, '')
      if (url) nav(url)
      else nav('/minha-conta')
    } catch { nav('/minha-conta') } finally { setLoading(false) }
  }

  return (
    <div className="max-w-xl mx-auto mt-6">
      <div className="bg-white rounded-2xl border border-neutral-200 shadow-sm overflow-hidden">
        <div className="h-1.5" style={{ background: 'linear-gradient(90deg, #ffcc00 0%, #ff6c00 100%)' }} />
        <div className="p-8 text-center">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-accent-50 border border-accent-200 flex items-center justify-center mb-5">
            <Lock className="text-accent-500" size={30} />
          </div>
          <h2 className="text-xl font-heading font-extrabold text-graphite">Recurso bloqueado</h2>
          <p className="text-sm text-gray-600 mt-2 max-w-md mx-auto">
            Este recurso é liberado após a ativação da sua licença. Finalize o pagamento para desbloquear
            <b> todos os recursos da plataforma The Conect</b> — clientes, conexões, rede, comissões, carteira e muito mais.
          </p>
          <button onClick={finalizar} disabled={loading}
            className="mt-6 inline-flex items-center gap-2 rounded-xl text-white font-bold px-6 py-3 disabled:opacity-60 hover:brightness-105 transition"
            style={{ background: 'linear-gradient(135deg, #ffcc00, #ff6c00)' }}>
            {loading ? 'Abrindo pagamento...' : 'Finalizar Pagamento'} <ArrowRight size={16} />
          </button>
          <div className="mt-4">
            <button onClick={() => nav('/universidade')}
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-600 hover:underline">
              <GraduationCap size={15} /> Enquanto isso, conheça o Plano de Negócios
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
